import PopularDestinations from './PopularDestinations'

export default PopularDestinations
